export const EVENT_COLLECTOR_DEV_TOOL_EVENTS_KEY =
  'eventCollectorDevToolEvents';

export default class EventsHistory<T> {
  private events: T[];

  constructor() {
    const storedEvents = sessionStorage.getItem(
      EVENT_COLLECTOR_DEV_TOOL_EVENTS_KEY,
    );

    if (storedEvents === null) {
      this.events = [];
    } else {
      this.events = JSON.parse(storedEvents);
    }
  }

  clear() {
    this.events = [];
    sessionStorage.removeItem(EVENT_COLLECTOR_DEV_TOOL_EVENTS_KEY);
  }

  getAll() {
    return this.events;
  }

  add(event: T) {
    this.events.push(event);
    sessionStorage.setItem(
      EVENT_COLLECTOR_DEV_TOOL_EVENTS_KEY,
      JSON.stringify(this.events),
    );
  }

  size() {
    return this.events.length;
  }
}
